// extracted by mini-css-extract-plugin
export default {"section":"BoxSamplesSlider_section__v8T77","container":"BoxSamplesSlider_container__s6Xng","title":"BoxSamplesSlider_title__4qwCG","subtitle":"BoxSamplesSlider_subtitle__z6q3F"};